import { Button, Dialog, Portal, Text } from '@chakra-ui/react';
import { FC } from 'react';

export type DeleteUserDialogProps = {
  isOpen: boolean;
  isLoading: boolean;
  memberName?: string | null;
  memberEmail?: string | null;
  error?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
};

const DeleteUserDialog: FC<DeleteUserDialogProps> = ({
  isOpen,
  isLoading,
  memberName,
  memberEmail,
  error,
  onCancel,
  onConfirm,
}) => {
  const displayName = memberName?.trim() || memberEmail || 'this user';

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={({ open }) => {
        if (!open) {
          onCancel();
        }
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.CloseTrigger />
            <Dialog.Header flexDirection={'column'}>
              <Dialog.Title>Remove user</Dialog.Title>
              <Dialog.Description>
                Are you sure you want to remove{' '}
                <Text as="span" fontWeight="bold">
                  {displayName}
                </Text>{' '}
                from this organization?
              </Dialog.Description>
            </Dialog.Header>
            <Dialog.Body>
              {error ? (
                <Text color="fg.error" fontSize="sm">
                  {error}
                </Text>
              ) : null}
            </Dialog.Body>
            <Dialog.Footer gap="3" justifyContent="flex-end">
              <Button variant="ghost" onClick={onCancel} disabled={isLoading}>
                Cancel
              </Button>
              <Button
                colorPalette="red"
                onClick={onConfirm}
                loading={isLoading}
                disabled={isLoading}
              >
                Remove user
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default DeleteUserDialog;
